<template>
  <div id="app">
    <header-component v-if="$route.name !== 'Login' && $route.name !== 'RegisterUser'"></header-component>
    <router-view/>
    <div class="footer" v-if="$route.name !== 'Login' && $route.name !== 'RegisterUser'">Copyright © 2022 www.hangzhourenge.cn 浙ICP备2022018352号-2</div>
    <tools-box v-if="$route.name !== 'Login' && $route.name !== 'RegisterUser'"></tools-box>
    <login-tool v-if="($route.name === 'Home' || $route.name === 'JobWanted' || $route.name === 'Recruit') && !$store.get('user')"></login-tool>
    <news-tool v-if="($route.name !== 'Login' && $route.name !== 'RegisterUser' && screenW > 1366)"></news-tool>
  </div>
</template>

<script>
import HeaderComponent from './components/Head/HeaderComponent'
import ToolsBox from './components/ToolsBox/ToolsBox'
import LoginTool from './components/LoginTool/LoginTool'
import NewsTool from './components/NewsTool/NewsTool'
export default {
  name: 'App',
  components: {NewsTool, LoginTool, ToolsBox, HeaderComponent},
  data () {
    return {
      screenW: screen.width
    }
  }
}
</script>

<style>
  html,body {
    width: 100vm;
    height: 100vh;
    margin: 0;
    font-size: 14px;
    background: #f4f4f4;
    /*noinspection CssInvalidPropertyValue*/
    overflow: overlay;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: auto;
  min-height: 100%;
  width: 100%;
}
  .footer {
    color: #cccccc;
    font-size: 18px;
    line-height: 100px;
  }

  body::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #fff;
  }
  body::-webkit-scrollbar-thumb {
    border-radius:5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: rgba(0, 0, 0, .1)
  }

  /deep/ .person-data>section>.el-drawer__body{
    overflow-y: scroll !important;
    overflow-x: hidden !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue